import { useCallback } from "react";
import { useApi } from "./api";
import { SendHelpRequestBody } from "./types/helpRequests";

/** The multipart form shared by the help requests and the feedback. */
export const buildHelpRequestFormData = (body: SendHelpRequestBody): FormData => {
  const formData = new FormData();
  formData.append("subject", body.subject);
  formData.append("message", body.message);
  formData.append("diagnostics", JSON.stringify(body.diagnostics));
  if (body.screenshot) formData.append("screenshot", body.screenshot, "screenshot.jpg");
  for (const file of body.attachments) {
    formData.append("attachments", file, file.name);
  }
  return formData;
};

export const useHelpRequestsApi = () => {
  const api = useApi();

  // Send a help request to the technical consulting team
  const sendHelpRequest = useCallback(
    (body: SendHelpRequestBody) => api.postNoResult<FormData>("/help_requests", buildHelpRequestFormData(body)),
    [api],
  );

  return { sendHelpRequest };
};
